"use scrict";

import textFit from 'textFit';

global.$ = require("jquery");
window.jQuery = $;
var MobileDetect = require('mobile-detect');

window.prevScroll = 0;
window.navPush = 0;
window.blocks = $('.block');

$(window).on('pageshow', function(){
   setTimeout(function(){
      $('body').addClass('in').removeClass('out');
      window.scrollActive = true;
      $(window).trigger('scroll');
   }, 100);
});

$(function(){

   $('main > h1, main > h2, main > h3, main > h4').each(function(){
      $(this).html($(this).html().replaceAll('*', `<img src="https://buddydog.guru/assets/img/buddydog-smooth.png">`));
   });

   $('.menu-button').on('click', function(e){
      e.preventDefault();
      $('.mob-nav').toggleClass('show');
   });

   $('.listblock a, #menuhooks > a').on('click', function(e){
      e.preventDefault();
      var href = $(this).attr('href');
      var tar = $(href);
      if(tar) {
         var pos = $(tar).offset().top;
         $('html,body').animate({'scrollTop':pos}, 400);
      }

      $('.mob-nav').removeClass('show');
   });

   $('.slides video').on('click', function(e){
      $('video').not(this).each(function(){
         if(!this.paused) {
            this.pause();
            this.muted = true;
            $(this).addClass('paused');
         }
      });
      if(this.paused) {
         this.play();
         this.muted = false;
         $(this).removeClass('paused');
      } else {
         this.pause();
         this.muted = true;
         $(this).addClass('paused');
      }
   });

   $('.bigbutton--inner').on('click', function(){
      if($(this).find('a').length>0){
         var href = $(this).find('a').first().attr('href');
         $('body').addClass('out');
         setTimeout(function(){
            window.location.href = href;
         }, 500);
      }
   });

   $('video').each(function(){
      this.onended = function(v){ 
         console.log(v);
         this.currentTime = 0;
         $(this).addClass('paused');
      };
   });

   $(`a[href*="${window.location.host}"], a[href^="./"]`).on('click', function(e){
      e.preventDefault();
      var href = $(this).attr('href');
      $('body').addClass('out');
      setTimeout(function(){
         window.location.href = href;
      }, 500);
   });

   $('.listblock li, .mob-nav a').each(function(){
      let rnd = Math.random()*6 - 3;
      $(this).css('transform',`rotate(${rnd}deg)`);
  });

   window.blocks = $('.block, main > h1, main > h2, main > h3, main > h4, main > h5');

   $(window).on('scroll', function(){
      if(window.scrollActive) {
         let limit = window.innerWidth < window.innerHeight ? window.innerHeight*.85 : window.innerHeight*.9;
         for(var i=0;i<window.blocks.length;i++) {
         var t = window.blocks[i];
         var rect = t.getBoundingClientRect();
   
         var inview = rect.top < limit && rect.bottom > 0;
   
         if(inview){
            $(t).addClass('in');
         }
         }

         if($(window).scrollTop() > 80 && $(window).scrollTop() > window.prevScroll){
            window.navPush += ($(window).scrollTop() - window.prevScroll);
            if(window.navPush > 50) {
               if(window.innerWidth<787 && $('.mob-nav').hasClass('show')){
                  $('nav.nav').removeClass('fold');
               } else {
                  $('nav.nav').addClass('fold');
               }
            }
         } else {
            $('nav.nav').removeClass('fold');
            window.navPush = 0;
         }

         window.prevScroll = $(window).scrollTop();
      }
   });

   initSlides();

   setTimeout(function(){
      $('body').addClass('in');
      window.scrollActive = true;
      $(window).trigger('scroll');
   }, 100);
});

function initSlides(){
   if(window['projectanims']){
     for(var i=0; i<window['projectanims'].length; i++){
       window.clearInterval(window.projectanims[i]);
     }
   }
   window.projectanims = [];
   $('[data-duration]').each(function(idx){
     var id = $(this).attr('id');
     if(id==undefined) {
       id = $(this).parents('.imageset').attr('id');
     }
     var duration = $(this).attr('data-duration')*1000;
 
     var container = this;
     var interval_id = `intervals_${id}`;
     // window.clearInterval(window.projectanims[interval_id]);
     window.projectanims[idx] = setInterval(function(){
       var curAct = container.querySelector('.act');
       if(curAct){
         var next = curAct.nextElementSibling;
         if(!next) { next = container.querySelector('li'); }
         curAct.classList.remove('act');
         curAct.classList.add('out');
         next.classList.add('act');

         setTimeout(function(){
            curAct.classList.remove('out');
         }, duration*.9);
       }
     }, duration);
   });
 }